import React, { useState } from 'react'
import { deletclassProps } from './deleteclass-interface'
import { Alert, Button, Modal } from 'antd'
import { openNotificationWithIcon } from '../../../../../../utils/helper'
import { deleteClass } from '../../../../../../api/class/class'
import { useNavigate } from 'react-router-dom'

const Deleteclass = ({ open, closeModal, classId }: deletclassProps) => {
	const navigate = useNavigate()

	const [loading, setLoading] = useState(false)
	const [error, setError] = useState<any>(null)


	const onFinish = async () => {
		try {
			setLoading(true)
			setError(null)

			const res = await deleteClass(classId)

			const { message } = res.data

			openNotificationWithIcon("success", "Delete Class", message || 'Class deleted successfully')
			setLoading(false)
			navigate(`/teacher/dashboard/classes`)
			closeModal(true)

		} catch (error: any) {
			setLoading(false)
			if (error?.response) {
				openNotificationWithIcon('error', 'Delete Class', `${error?.response?.data?.message || 'Something went wrong'}`)
			} else {
				openNotificationWithIcon('error', 'Delete Class', 'Something went wrong')
			}

		}
	}

	return (
		<div>
			<Modal
				closable={false}
				open={open}
				onOk={() => {
					if (!loading) {
						closeModal()
					}
				}}
				onCancel={() => {
					if (!loading) {
						closeModal()
					}
				}}
				footer={null}
				width={'38rem'}
				className='white-bg-modal'
			>
				<div>
					<div className='flex border-b border-appcolorgreyfour pb-[0.75rem] justify-between items-center'>
						<h1 className='text-[22px] leading-[110%] font-semibold text-appcolorgrey mb-[-1rem]'>Delete Class</h1>
						<div className='rounded-full bg-appcolorgreyfive custom-box-shadow-five p-[0.9rem] w-fit cursor-pointer'
							onClick={() => {
								if (!loading) {
									closeModal()
								}
							}}
						>
							<img src="/img/vectors/modalclose.svg" alt="" />
						</div>
					</div>

					<div className='mt-[2rem]'>
						{
							error !== null ?
								<div className='mb-4'>
									<Alert message={error} type="error" />
								</div>
								: null
						}

						<p className='text-base'>Are you sure you want to delete this class? </p>

						<div className='mt-[2.5rem] flex justify-end'>
							<Button
								onClick={() => {
									if (!loading) {
										closeModal()
									}
								}}
								style={{
									color: '#200E32 !important'
								}}
								disabled={loading}
								className='mr-[0.9rem] custom-white-btn black-text smaller-padding'>

								Cancel
							</Button>

							<Button
								disabled={loading}
								className='custom-primary-two-btn smaller-padding'
								loading={loading}
								onClick={() => {
									onFinish()
								}}
							>
								Continue
							</Button>
						</div>
					</div>
				</div>
			</Modal>
		</div>
	)
}

export default Deleteclass